export default "ISO 50001 — Système de management de l'énergie industriel | Solution Éco France";
